var render = function render(){var _vm=this,_c=_vm._self._c;return _c('uploadList',{attrs:{"uploadType":"audio","uploadTitle":"点击上传本地音频","btnTitle":"","accept":['.mp3'],"limit":11,"uploadSize":"2gb"}})
}
var staticRenderFns = []

export { render, staticRenderFns }